import styled from "styled-components";

const ProfilePanelData = styled.div`
  width: 225px;
  text-align: right;
  word-break: break-word;
`;

export default ProfilePanelData;
